import tw, { TwStyle } from 'twin.macro';

import { Dropdown, IDropdownOption } from '@components/Dropdown';
import { RoleCellType, UserRoleType } from '@account_module/types/Organizations';
import { USER_ROLE_KEY } from '@account_module/constants/userKeys';
import { Loader } from '@components/Loader';

const Capitalized = tw.span`capitalize`;
const Option = tw.span`flex items-center justify-start py-[6px] px-1 cursor-pointer hover:bg-gray-3 rounded-[3px]`;
const LoaderContainer = tw.div`w-8 ml-0`;
const labelStyle =
  tw`border-none shadow-none text-[11px] bg-page-background text-text-and-icon px-[4px] hover:bg-gray-3 rounded-[4px] [&>svg]:hidden hover:[&>svg]:block` as TwStyle;
const selectedLabelStyle =
  tw`border-none shadow-none text-[11px] px-[4px] bg-gray-3 rounded-[4px] [&>svg]:block` as TwStyle;
const dropdownMenuStyle = tw`p-0.5 -mt-1 bg-neutral-background` as TwStyle;

const options: IDropdownOption[] = [
  {
    value: USER_ROLE_KEY.admin,
    label: <Option>Admin</Option>,
  },
  {
    value: USER_ROLE_KEY.editor,
    label: <Option>User</Option>,
  },
  {
    value: USER_ROLE_KEY.viewer,
    label: <Option>Viewer</Option>,
  },
];

export const RoleCell = ({
  item,
  isLoading,
  currentUser,
  selectedRow,
  setSelectedRow,
  onChange,
  setIsActionCtxOpen,
}: RoleCellType): JSX.Element => {
  const { id, role } = item;
  const currentOption = options.find((opt) => opt?.value === role) as IDropdownOption;

  const _labelStyle = selectedRow === id ? selectedLabelStyle : labelStyle;

  const handleChange = (val: IDropdownOption) => {
    const { value } = val as IDropdownOption;

    if (value !== role) {
      onChange(value as UserRoleType);
    }
  };

  if (isLoading) {
    return (
      <LoaderContainer>
        <Loader size='sm' theme='dark' tw='m-0' />
      </LoaderContainer>
    );
  }

  return (
    <Capitalized
      onClick={() => {
        setIsActionCtxOpen(false);
        if (selectedRow === id || isLoading) return;
        setSelectedRow(id);
      }}>
      <Dropdown
        isPresentational={!currentUser.isAdmin}
        value={currentOption}
        options={options}
        onChange={(val) => handleChange(val as IDropdownOption)}
        labelStyle={_labelStyle}
        dropdownMenuStyle={dropdownMenuStyle}
      />
    </Capitalized>
  );
};
